import * as React from "react";
import { Context } from "./_context";
export const CaretUpIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.5 6a.75.75 0 0 1 1.06 0l4.5 4.5L12 11.56 8.03 7.59l-3.97 3.97L3 10.5 7.5 6Z", fill: "currentColor" }));
  return iconset[size];
};
CaretUpIcon.iconId = "D2pNCd";
